import type { ChatSession as ChatSessionType } from "@whop/embedded-components-vanilla-js/types";

import { useRef } from "react";

export function useChatSessionRef() {
	const ref = useRef<{
		chatSession: ChatSessionType | null;
	}>(null);
	return ref;
}
